<template>
  <div class="conatiner-fluid mt-2">
    <div v-if="cmsEditorShow" id="formularEditor" class="formEditor">
      <PageBuilder ref="cmsEditor" @close="closePageBuilder" mode="workflows" @save="saveUserTaskForm" @ready="initEditor" :cmsDoc="cmsID"/>
    </div>
    <div class="row" id="baseview">
      <div class="col">
        <h2>ProzessEditor: {{ process.process.attributes.name.value }}</h2>
      </div>
      <div class="col">
        <h4 style="color: red;">Nur teilweise funktionsfähig</h4>
      </div>
    </div>
    <div class="btn-toolbar" role="group">
      <div class="btn-group mr-3">
        <button @click="uploadProcess" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Repository Speicher</button>
      </div>
      <div class="btn-group mr-3">
        <button @click="saveProcess" class="btn btn-secondary"><font-awesome-icon icon="save"/>&nbsp;BPMN Speichern</button>
        <button @click="showBPMNUpload" class="btn btn-secondary"><font-awesome-icon icon="load"/>BPMN Laden</button>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col" style="max-width:78%;">
        <FlowEditor @add-edge="initEdge" @selectNode="showNode" @selectEdge="showEdge" ref="floweditor" :elements="elemGroups"/>
      </div>
      <div class="col-s" style="max-width:20%;">
        <b-tabs v-model="editTab">
          <b-tab title="Prozess">
            <div class="row m-2">
              <div class="col">
                <div class="form-group">
                  <label>ID</label>
                  <input type="text" v-model="process.process.attributes.id.value" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="row m-2">
              <div class="col">
                <div class="form-group">
                  <label>Name</label>
                  <input type="text" v-model="process.process.attributes.name.value" class="form-control"/>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Element">
            <BPMNUserTask         :item="editItem" v-if="editType == 'userTask'"         @updateName="updateName" @formOpen="showCMSEditor('userTask')"/>
            <BPMNScriptTask       :item="editItem" v-else-if="editType == 'scriptTask'"  @updateName="updateName"/>
            <BPMNNodeBase         :item="editItem" v-else-if="editType == 'base'"        @updateName="updateName"/>
            <BPMNMailTask         :item="editItem" v-else-if="editType == 'mailTask'"    @updateName="updateName"/>
            <BPMNGatewayExclusive :item="editItem" v-else-if="editType == 'excGateway'"  @updateName="updateName"/>
            <BPMNRemoteService    :item="editItem" v-else-if="editType == 'remoteTask'"  @updateName="updateName"/>
            <BPMNEdge             :item="editItem" v-else-if="editType == 'edge'"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal id="bpmnUpload" @ok="loadBPMNFile">
      <b-form-group label="Default:" label-cols-sm="2">
        <b-form-file id="bpmn-load"></b-form-file>
      </b-form-group>
    </b-modal>
  </div>
</template>

<style>
.wf-tb-area {
  cursor:pointer;
}
</style>

<script>
import bpmn from '@/modules/bpmn.js'
import cmsdocs from '@/modules/cmsdocs.js'
import PageBuilder from '@/components/digitalfirm/cms/PageBuilder.vue'
import flows from '@/modules/floweditor.js'
import FlowEditor from '@/components/flows/FlowEditor.vue'
import workflows from '@/modules/workflows.js'
import xmlutils from '@/modules/xmlutil.js'
import BPMNNodeBase from '@/components/flows/BPMNNodeBase.vue'
import BPMNEdge from '@/components/flows/BPMNEdge.vue'
import BPMNUserTask from '@/components/flows/BPMNUserTask.vue'
import BPMNScriptTask from '@/components/flows/BPMNScriptTask.vue'
import BPMNRemoteService from '@/components/flows/BPMNRemoteService.vue'
import BPMNMailTask from '@/components/flows/BPMNMailTask.vue'
import BPMNGatewayExclusive from '@/components/flows/BPMNGatewayExclusive.vue'
//import BPMNWebService from '@/components/flows/BPMNWebService.vue'

export default {
  name: 'ProcessEditor',
  components: {
    BPMNUserTask,
    BPMNScriptTask,
    BPMNEdge,
    BPMNMailTask,
    BPMNNodeBase,
    FlowEditor,
    PageBuilder,
    BPMNGatewayExclusive,
    BPMNRemoteService
  },
  data() {
    return {
      cmsEditorShow: false,
      cmsID: 0,
      process: { process: { attributes: { id: {"localName":"id","nodeName":"id","value":""}, name: {"localName":"name","nodeName":"name","value":""} }, children: [] } },
      processdef: {},
      defid: "",
      sourceType: false,
      nodeidcount: 0,
      editItem: { },
      editType: '',
      editNode: false,
      editTab: 0,
      elemGroups: [
        {
          title: 'Standards',
          name: 'default'
        },
        {
          title: 'Aufgaben',
          name: 'tasks'
        },
        {
          title: 'Steuerung',
          name: 'control'
        }
      ]
    }
  },
  mounted: function() {
    var self = this;

    this.$nextTick(function() {

      // create bpmn node and edge elements
      self.initElements();

      var pid = self.$route.params.defid;
      if (pid && pid != 'new') {
        this.loadProcess(self.$route.params.defid);
      }
    });
  },
  methods: {

    //
    // bpmn file in den editor Laden
    //
    loadBPMNFile() {
      var input = document.getElementById('bpmn-load');
      console.log(input);
      if (input.files && input.files.length > 0) {
        console.log(input.files[0].name);
      }
    },

    // update node and edge names on graph
    updateName(e) {
      if (this.editNode) {
        this.editNode.node.attr({label: { text: e }});
      }
    },

    //
    // show bpmn upload dialog
    //
    showBPMNUpload() {
      this.$bvModal.show('bpmnUpload');
    },


    //
    // show editor for type of content x
    //
    showCMSEditor(type) {
      console.log('editor',type);
      var cmsDoc = false;
      var attr = xmlutils.jsonxmlattr(this.editItem,"http://activiti.org/bpmn","formKey");
      console.log('show editor',attr);
      if (attr)
        cmsDoc = Number(attr.value);

      if (cmsDoc > 0) {
        this.cmsID = cmsDoc;
      } else {
        this.cmsID = 0;
      }

      this.cmsEditorShow = true;
    },

    async initEditor() {
      await this.$refs.cmsEditor.createEditor('workflows');
      if (this.cmsID > 0) this.$refs.cmsEditor.loadDocument();
    },

    comp2text(root,field) {
      if (root.components) {
        for (var i in root.components) {
          var entry = root.components[i];
          if (entry.content) {
            field.question += entry.content;
          } else {
            this.comp2text(entry,field);
          }
        }
      }
    },

    //
    // parse question details
    //
    readQuestion(root,field) {
      if (root.components) {
        for (var i in root.components) {
          var entry = root.components[i];
          if (entry.type == 'wf-input') {
            // TODO types
            console.log('todo type reading');
          } else if (entry.type == 'label') {
            field.question = '';
            this.comp2text(entry,field);
            console.log('question',field);
          } else {
            this.readQuestion(entry,field);
          }
        }
      }
    },

    //
    // parse questions from formular document
    //
    readFormFields(root,fields) {
      if (root.components) {
        for (var i = 0;i < root.components.length;i++) {
          var entry = root.components[i];
          if (entry.type == 'wf-text-input') {
            if (entry.attributes.variable) {
              var varname = entry.attributes.variable;
              console.log('found field: ' + varname);
              var field = { "variable": varname, "question":entry.attributes.question, "type":"string", "required":false, "id":varname };
              this.readQuestion(entry,field);
              fields.push(field);
            }
          } else if (entry.components && entry.components.length > 0) {
            this.readFormFields(entry,fields);
          }
        }
      }
    },

    //
    // save a user task formular document to backend
    // and update bpmn formular fields / questions
    //
    async saveUserTaskForm(data) {

      // read form fields from document
      var fields = [];
      this.readFormFields(data.content.pages[0].frames[0].component,fields);

      // check document link to user task element
      var docId = xmlutils.jsonxmlattr(this.editItem,"http://activiti.org/bpmn","formKey");
      if (!docId) {
        console.warn('Keine cmsDoc Link gefunden',this.editItem);
        // TODO creaet some
        docId = {
          "localName":"formKey",
          "nodeName":"formKey",
          "ns":"http://activiti.org/bpmn",
          "value": 0
        };
        this.editItem.attributes["formKey"] = docId;
      }
      console.log('after id set',this.editItem);
      var doc = { id: docId.value, catID: 0, docType: 3, docLink: 0, export: false, docTree: 'workflow-forms', label: this.editItem.attributes.id.value, locale: 'de', document: '', documentData: JSON.stringify(data.content), fallback: false };

      doc.styles   = this.$refs.cmsEditor.getCss();
      doc.script   = this.$refs.cmsEditor.getJs();
      doc.document = this.$refs.cmsEditor.getHtml();
      console.log('set document to save',doc.document);

      try {
        doc = await cmsdocs.saveDocument(doc);
        docId.value = doc.id;
        this.$bvToast.toast('Dokument gespeichert',{variant: 'success', title: 'CMS Formular'});
      } catch (error) {
        this.$bvToast.toast('Fehler beim Speicher: ' + JSON.stringify(error),{variant: 'danger', title: 'CMS Formular'});
        return;
      }

      // integrate form fields to bpmn
      var formular = xmlutils.jsonxmlchild(this.editItem,'extensionElements');
      if (!formular) {
        formular = {
          "localName":"extensionElements",
          "nodeName":"extensionElements",
          "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
          "type":1,
          "attributes":{},
          "children": []
        };
        this.editItem.children.push(formular);
      }
      formular.children = [];
      for (var f in fields) {
        var field = fields[f];
        var formField = {
          "localName":"formProperty",
          "nodeName":"activiti:formProperty",
          "ns":"http://www.activiti.org/test",
          "type":1,
          "attributes": {
            "name": { "localName":"name", "nodeName":"name", "value": field.question },
            "type": { "localName":"type", "nodeName":"type", "value": field.type },
            "variable": { "localName":"variable", "nodeName":"variable", "value": field.variable },
            "id": { "localName":"id", "nodeName":"id", "value": field.variable },
            "required": {"localName":"required", "nodeName":"required", "value": field.required }
          }
        };
        formular.children.push(formField);
      }

    },

    //
    // close page builder view
    //
    closePageBuilder() {
      this.cmsEditorShow = false;
    },

    //
    // open node detail view
    //
    showNode(node) {
      this.editItem = node.node.getData();
      this.editType = this.getEditType(this.editItem);
      console.log('selected',this.editType);
      this.editNode = node;
      this.editTab = 1;
    },

    getEditType(item) {
      var taskCheck = xmlutils.jsonxmlattr(item,'http://activiti.org/bpmn','class');
      if (item.localName == 'userTask') {
        return 'userTask';
      } else if (item.localName == 'startEvent' || item.localName == 'endEvent') {
        return 'base';
      } else if (item.localName == 'exclusiveGateway') {
        return 'excGateway';
      // check based on java implementation
      } else if (taskCheck && taskCheck.value) {
        if (taskCheck.value == 'trendshop.logic.workflow.http.RemoteServiceTask') {
          return 'remoteTask';
        } else if (taskCheck.value == 'trendshop.logic.workflow.ExtendedScriptTask') {
          return 'scriptTask';
        } else if (taskCheck.value == 'trendshop.logic.workflow.mail.JSONTemplateMail') {
          return 'mailTask';
        }
      }

      return false;
    },

    //
    // open edge detail view
    //
    showEdge(edge) {
      this.editItem = edge.edge.getData();
      this.editNode = edge;
      console.log('open edge',this.editItem);
      this.editTab = 1;
      this.editType = 'edge';
    },

    //
    // init new edge with base bpmn data
    //
    initEdge({ edge }) {
      console.log('init:',edge);
      var id = edge.id;
      var data = bpmn.newEdge('a' + id); // edget braucht ein buchstabe als erste id value
      edge.setData(data);
    },

    createBPMNXML() {
      var edges = this.$refs.floweditor.getEdges();
      var nodes = this.$refs.floweditor.getNodes();

      // bpmn json basic
      var bpmnjson = bpmn.newDoc();

      // process id prüfen
      if (!this.process.process.attributes.id.value || this.process.process.attributes.id.value == '') {
        alert('Sie müssen eine Prozess ID vergeben vor dem speichern.');
        return;
      }

      // add basic process root
      var process = bpmn.newProcess(this.process.process.attributes.id.value,this.process.process.attributes.name.value);

      // create basic diagram json
      var diagram = bpmn.newDiagram(this.process.process.attributes.id.value);

      // create plane for diagram
      var plane = bpmn.newDiagramPlane(this.process.process.attributes.id.value);

      diagram.children.push(plane);

      // insert nodes into bpmn
      for (var i in nodes) {
        var node = nodes[i];

        // update process xml
        process.children.push(node.getData());

        // update diagram view
        var data = node.getData();
        console.log('node',data);
        var rectNode = bpmn.newRectNode(data.attributes.id.value,node.position().x,node.position().y,node.size().width,node.size().height);

        plane.children.push(rectNode);

      }

      // insert edges into bpmn diagram
      for (var e in edges) {
        var edge = edges[e];
        var source = edge.getSourceNode().getData();
        var target = edge.getTargetNode().getData();
        if (source && target) {
          data = edge.getData();
          data.attributes.sourceRef = { "localName": "sourceRef", "nodeName":"sourceRef", "value": source.attributes.id.value };
          data.attributes.targetRef = { "localName": "targetRef", "nodeName":"targetRef", "value": target.attributes.id.value };
          process.children.push(data);

          // update bpmn diagram
          var edgeElem = {
            localName: 'BPMNEdge',
            nodeName: 'bpmndi:BPMNEdge',
            ns: "http://www.omg.org/spec/BPMN/20100524/DI",
            type: 1,
            attributes: {
              "bpmnElement": { "localName": "bpmnElement", "nodeName":"bpmnElement", "value": data.attributes.id.value },
              "id": {"localName":"id","nodeName":"id", "value":"BPMNShape_" + data.attributes.id.value }
            },
            children: [ // TODO check if start and endpoint placeholder waypoints needed for compatiblity with other bpmn diagramms
            ]
          };

          // add start point
          var sourcePos = edge.getSourcePoint();
          edgeElem.children.push({
            "localName":"waypoint",
            "nodeName":"omgdc:waypoint",
            ns: "http://www.omg.org/spec/DD/20100524/DI",
            "type":1,
            "attributes": {
              "x": { "localName":"x", "nodeName":"x", "value": sourcePos.x },
              "y": { "localName":"y", "nodeName":"y", "value": sourcePos.y }
            }
          });

          // TODO add vertices

          var endPos = edge.getTargetPoint();
          edgeElem.children.push({
            "localName":"waypoint",
            "nodeName":"omgdc:waypoint",
            "type":1,
            "ns": "http://www.omg.org/spec/DD/20100524/DI",
            "attributes": {
              "x": { "localName":"x", "nodeName":"x", "value": endPos.x },
              "y": { "localName":"y", "nodeName":"y", "value": endPos.y }
            }
          });


          plane.children.push(edgeElem);

        } else {
          console.warn('unconnected edge: ',edge);
        }
      }

      bpmnjson.root.children.push(process);
      bpmnjson.root.children.push(diagram);

      var serializer = new XMLSerializer();
      var xml        = '<?xml version="1.0" encoding="UTF-8"?>\n' + serializer.serializeToString(xmlutils.json2xml(bpmnjson));

      return xml;
    },

    //
    // save process as download
    //
    saveProcess() {
      console.log('save process');

      var xml = this.createBPMNXML();

      // activate download
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(xml));
      element.setAttribute('download', 'prozess.bpmn');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);

    },

    //
    // upload process bpmn direct to workflow engine
    //
    uploadProcess() {
      var xml  = this.createBPMNXML();
      var self = this;

      workflows.upload([new Blob([xml],{"type":"text/plain"})]).then(function(resp) {
        if (resp.status < 400) {
          self.$bvToast.toast('Prozessdefinition aktualisiert.',{title: 'Prozessdefinitionen',variant: 'success'})
        } else {
          resp.text().then(function(data) {
            self.$bvToast.toast('Fehler bei Prozess Upload: ' + data,{title: 'Prozess Upload',variant:'danger'});
          });
        }
      }).catch(function(err) {
        console.log('catch error',err);
        self.$bvToast.toast('Fehler bei Prozess Upload: ' + JSON.stringify(err),{variant: 'danger', title:'Prozess Upload'});
      })
    },

    //
    // load a process and convert to json
    //
    loadProcess(defid) {
      var self = this;
      workflows.loaddefxml(this,defid,function(data) {
        var parser   = new DOMParser();
        var xmlDoc   = parser.parseFromString(data,"text/xml");
        var procdata = xmlutils.xml2json(xmlDoc);
        self.process = flows.process2graph(procdata);

        // load Graph
        for (var i=0;i<self.process.graph.nodes.length;i++) {
          var n = self.process.graph.nodes[i];
          var elem = self.process.dict[n.id];
          //console.log('add node: ' + n.id);

          var label = '';
          if (elem.attributes && elem.attributes.name) label = elem.attributes.name.value;

          var nodeType = self.getEditType(elem);

          console.log('scriptCheck',nodeType);

          var node = false;
          if (elem.localName == 'startEvent') {
            node = self.$refs.floweditor.addNode({ shape: 'start', id: n.id, label: label , x: n.x, y: n.y });
          } else if (elem.localName == 'userTask') {
            node = self.$refs.floweditor.addNode({ shape: 'userTask', id: n.id, label: label , x: n.x, y: n.y });
          } else if (elem.localName == 'endEvent') {
            node = self.$refs.floweditor.addNode({ shape: 'end', id: n.id, label: label , x: n.x, y: n.y });
          } else if (elem.localName == 'exclusiveGateway') {
            node = self.$refs.floweditor.addNode({ shape: 'excGateway', id: n.id, label: label, x: n.x, y: n.y });
          } else if (nodeType == 'scriptTask') {
            node = self.$refs.floweditor.addNode({ shape: 'scriptTask', id: n.id, label: label, x: n.x, y: n.y });
          } else if (nodeType == 'mailTask') {
            node = self.$refs.floweditor.addNode({ shape: 'mailTask', id: n.id, label: label, x: n.x, y: n.y });
          } else if (nodeType == 'remoteTask') {
            node = self.$refs.floweditor.addNode({ shape: 'serviceTask', id: n.id, label: label, x: n.x, y: n.y });
          } else {
            console.warn('UNKNOWN NODE: ' + elem.nodeName);
          }
          if (node) {
            node.setData(elem,{ overwrite: true });
            if (elem.localName == 'userTask') console.log('node data',node.getData());
          }
        }

        for (i=0;i<self.process.graph.edges.length;i++) {
          var e = self.process.graph.edges[i];
          var edge = self.$refs.floweditor.addEdge({ source: e.source, target: e.target, vertices: e.vertices });
          elem = self.process.dict[e.id];
          //console.log(JSON.stringify(elem));
          edge.setData(elem);
        }

        //self.$refs.graph.setGraphData(self.process.graph);
      });
    },

    //
    // register bpmn graph elements
    //
    initElements() {
      this.$refs.floweditor.registerNode(
        'start',
        {
          inherit: 'circle',
          width: 60,
          height: 60,
          r: 60,
          attrs: {
            body: {
              strokeWidth: 2,
              stroke: '#2d2e2e',
              fill: '#bbdbb4',
            },
          },
          data: {
            "localName":"startEvent",
            "nodeName":"startEvent",
            "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
            "type":1,
            "attributes": {
              "id": {"localName":"id","nodeName":"id","value":"startevent1"},
              "name":{"localName":"name","nodeName":"name","value":"Start"}
            }
          }
        },
        true,);

        this.$refs.floweditor.registerNode(
          'end',
          {
            inherit: 'circle',
            width: 60,
            height: 60,
            r: 60,
            attrs: {
              body: {
                strokeWidth: 2,
                stroke: '#2d2e2e',
                fill: '#d9b4b8',
              },
            },
            data: bpmn.endEvent()
          },
          true,);

        this.$refs.floweditor.registerNode(
          'userTask',
          {
            inherit: 'rect',
            width: 110,
            height: 60,
            attrs: {
              body: {
                strokeWidth: 2,
                stroke: '#2d2e2e',
                fill: '#86aae3',
                rx: 10,
                ry: 10,
              },
            },
            data: {
              "localName":"userTask",
              "nodeName":"userTask",
              "type":1,
              "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
              "attributes": {
                "id": { "localName":"id","nodeName":"id","value":"usertask1"},
                "name": {"localName":"name","nodeName":"name","value":"Benutzeraufgabe"},
                "activiti:assignee": {"localName":"assignee","nodeName":"activiti:assignee","value":"unknown","ns":"http://activiti.org/bpmn"},
                "activiti:formKey": {"localName":"formKey","nodeName":"activiti:formKey","value":0, "ns":"http://activiti.org/bpmn"}
              },
              "children": [
                {
                  "localName":"documentation",
                  "nodeName":"documentation",
                  "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
                  "type":1,
                  "attributes":{},
                  "children":[]
                },
                {
                  "localName":"extensionElements",
                  "nodeName":"extensionElements",
                  "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
                  "type":1,
                  "attributes":{},
                  "children": []
                }
              ]
            }
          },
          true,);

          this.$refs.floweditor.registerNode(
            'scriptTask',
            {
              inherit: 'rect',
              width: 110,
              height: 60,
              attrs: {
                body: {
                  strokeWidth: 2,
                  stroke: '#2d2e2e',
                  fill: '#d289d6',
                  rx: 10,
                  ry: 10,
                },
              },
              data: {
                "localName":"serviceTask",
                "nodeName":"serviceTask",
                "type":1,
                "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
                "attributes": {
                  "id": {"localName":"id","nodeName":"id","value":"scriptTask1" },
                  "name": {"localName":"name","nodeName":"name","value":"Script" },
                  "activiti:class": { "localName":"class","nodeName":"activiti:class","value":"trendshop.logic.workflow.ExtendedScriptTask","ns":"http://activiti.org/bpmn"}
                },
                "children":[
                  {
                    "ns":"http://www.omg.org/spec/BPMN/20100524/MODEL",
                    "localName":"extensionElements",
                    "nodeName":"extensionElements",
                    "type":1
                  }
                ]
              }
            },
            true,);

            this.$refs.floweditor.registerNode(
              'mailTask',
              {
                inherit: 'rect',
                width: 110,
                height: 60,
                attrs: {
                  body: {
                    strokeWidth: 2,
                    stroke: '#2d2e2e',
                    fill: '#f5e056',
                    rx: 10,
                    ry: 10,
                  },
                },
                data: {
                  "localName":"serviceTask",
                  "nodeName":"serviceTask",
                  "type":1,
                  "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
                  "attributes": {
                    "id": {"localName":"id","nodeName":"id","value":"mailTask1" },
                    "name": {"localName":"name","nodeName":"name","value":"Script" },
                    "activiti:class": { "localName":"class","nodeName":"activiti:class","value":"trendshop.logic.workflow.mail.JSONTemplateMail","ns":"http://activiti.org/bpmn"}
                  },
                  "children":[
                    {
                      "ns":"http://www.omg.org/spec/BPMN/20100524/MODEL",
                      "localName":"extensionElements",
                      "nodeName":"extensionElements",
                      "type":1
                    }
                  ]
                }
              },
              true,);

              this.$refs.floweditor.registerNode(
                'serviceTask',
                {
                  inherit: 'rect',
                  width: 110,
                  height: 60,
                  attrs: {
                    body: {
                      strokeWidth: 2,
                      stroke: '#2d2e2e',
                      fill: '#52e3d9',
                      rx: 10,
                      ry: 10,
                    },
                  },
                  data: {
                    "localName":"serviceTask",
                    "nodeName":"serviceTask",
                    "type":1,
                    "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
                    "attributes": {
                      "id": {"localName":"id","nodeName":"id","value":"remoteTask1" },
                      "name": {"localName":"name","nodeName":"name","value":"Service" },
                      "activiti:class": { "localName":"class","nodeName":"activiti:class","value":"trendshop.logic.workflow.http.RemoteServiceTask","ns":"http://activiti.org/bpmn"}
                    },
                    "children":[
                      {
                        "ns":"http://www.omg.org/spec/BPMN/20100524/MODEL",
                        "localName":"extensionElements",
                        "nodeName":"extensionElements",
                        "type":1
                      }
                    ]
                  }
                },
                true,);


              this.$refs.floweditor.registerNode(
                'excGateway',
                {
                  width: 60,
                  height: 60,
                  markup: [
                    {
                      tagName: 'path',
                      selector: 'body1',
                      groupSelector: 'body',
                      attrs: {
                        d:
                          'm0,30l30,-30l30,30l-30,30l-30,-30z',
                      },
                    },
                    {
                      tagName: 'path',
                      selector: 'cross',
                      attrs: {
                        d: "m15,15l30,30m-30,0l30,-30",
                      }
                    }
                  ],
                  attrs: {
                    body: {
                      strokeWidth: 2,
                      stroke: '#2d2e2e',
                      fill: '#EFF4FF',
                    },
                    cross: {
                      strokeWidth: 2,
                      stroke: '#2d2e2e',
                    },
                  },
                  data: {
                    "localName":"exclusiveGateway",
                    "nodeName":"exclusiveGateway",
                    "type":1,
                    "ns": "http://www.omg.org/spec/BPMN/20100524/MODEL",
                    "attributes": {
                      "id": {"localName":"id","nodeName":"id","value":"excGateway1" },
                      "name": {"localName":"name","nodeName":"name","value":"excGateway1" },
                      "default": {"localName":"default", "nodeName":"default","value":""}
                    }
                  }
                },
                true,);


        const start = this.$refs.floweditor.createNode({ shape: 'start', label: 'Start' });
        const end   = this.$refs.floweditor.createNode({ shape: 'end', label: 'Ende' });

        const userTask    = this.$refs.floweditor.createNode({shape:'userTask', label: 'Aufgabe' });
        const scriptTask  = this.$refs.floweditor.createNode({shape:'scriptTask', label: 'Script' });
        const mailTask    = this.$refs.floweditor.createNode({shape:'mailTask', label: 'E-Mail' });
        const serviceTask = this.$refs.floweditor.createNode({shape: 'serviceTask', label: 'RemoteService' });
        // TODO tasks
        // berichte
        // bflows

        const excGateway = this.$refs.floweditor.createNode({ shape: 'excGateway', label: '' });


        this.$refs.floweditor.fillElementGroup([start,end],'default');
        this.$refs.floweditor.fillElementGroup([userTask,mailTask,scriptTask,serviceTask],'tasks');
        this.$refs.floweditor.fillElementGroup([excGateway],'control');

    }
  }
}
</script>

<style scoped>
.formEditor {
  position:   relative;
  top:        0px;
  left:       0px;
  width:      100%;
  height:     2000px;
  z-index:    10;
}
</style>
